import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PristinePv from "./pages/pristinepv";
import ScrollToTop from "./scrollToTop";
import SignIn from "./pages/signin";
import SignUp from "./pages/signup";
import PrivateComponent from "./privateComponent";

import Dashboard from "./pages/dashboard";
import Preview from "./incpection.com/pages/report";
import ProjectNew from "./incpection.com/pages/projectNew";
import QuotationPage from "./pages/quotation";

// Public legal/account pages
import PrivacyPolicy from "./pages/privacyPolicy";
import TermsAndConditions from "./pages/termsAndConditions";
import DeleteAccount from "./pages/deleteAccount";
import RecoverAccount from "./pages/recoverAccount";

function App() {
  return (
    <div className="App" style={{ position: "relative" }}>
      <BrowserRouter>
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<PristinePv />} />

          {/* Public quotation routes */}
          <Route path="/quotation/:token" element={<QuotationPage />} />

          {/* Public legal/account routes */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />

          <Route path="/delete-account" element={<DeleteAccount />} />

          <Route path="/recover-account" element={<RecoverAccount />} />

          {/* Authentication routes */}
          <Route path="/pristinepvSignUp" element={<SignUp />} />

          <Route path="/pristinepvSignIn" element={<SignIn />} />

          {/* Private routes */}
          <Route element={<PrivateComponent />}>
            <Route path="/dashboard" element={<Dashboard />} />

            <Route path="/createProject" element={<ProjectNew />} />

            <Route path="/preview" element={<Preview />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
